<!--
 * @Author:
 * @LastEditTime: 2023-07-28
 * @Description: 隐患排查任务
-->
<template>
  <el-card class="h-full">
    <div class="h-full relative">
      <el-tabs v-model="activeName">
        <el-tab-pane label="设备设施类" name="equip">
          <task-equip-table v-if="activeName === 'equip'"></task-equip-table>
        </el-tab-pane>
        <el-tab-pane label="作业活动类" name="job">
          <task-job-table v-if="activeName === 'job'"></task-job-table>
        </el-tab-pane>
        <el-tab-pane label="基础管理类" name="base">
          <task-base-table v-if="activeName === 'base'"></task-base-table>
        </el-tab-pane>
      </el-tabs>
    </div>
  </el-card>
</template>

<script>
import TaskEquipTable from '../components/Task/TaskEquipTable'
import TaskBaseTable from '../components/Task/TaskBaseTable'
import TaskJobTable from '../components/Task/TaskJobTable'

export default {
  name: 'task-child',
  components: {
    TaskEquipTable,
    TaskBaseTable,
    TaskJobTable,
  },
  created() {
    // tagType 1为设备设施 2为作业活动 3为基础管理
    if (this.$route.query.tagType == 2) {
      this.activeName = 'job'
    } else if (this.$route.query.tagType == 3) {
      this.activeName = 'base'
    } else {
      this.activeName = 'equip'
    }
  },
  data() {
    return {
      activeName: 'equip',
    }
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-card__body {
  height: 100%;
}
::v-deep .el-tabs {
  height: 100%;
}
::v-deep .el-tabs__content {
  height: calc(100% - 54px) !important;
  position: inherit;
  .el-tab-pane {
    height: 100%;
  }
}
</style>
